import { render, staticRenderFns } from "./DriveItem.vue?vue&type=template&id=194ce3b0&scoped=true&"
import script from "./DriveItem.ts?vue&type=script&lang=ts&"
export * from "./DriveItem.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ce3b0",
  null
  
)

export default component.exports